import {
  CssBaseline,
  Divider,
  Drawer,
  ListItem,
  ListItemIcon,
  ListItemText,
  Popover,
  Theme,
  List,
  useTheme,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import {
  CcfAccordion,
  CcfAccordionDetails,
  CcfAccordionSummary,
  CcfAssignmentCollapseIcon,
  CcfTypography,
  CcfAcdContactSettingIcon,
  CcfAcdOutboundIcon,
  CcfAcdListsIcon,
  CcfAcdSettingsIcon,
  CcfAcdConfigurationIcon,
  CcfAcdSupportIcon,
  CcfAcdDFOIcon,
  CcfTagsIcon,
  CcfChatProfileIcon,
  CcfHoursofOperationIcon,
  CcfSMSRegistrationIcon,
  CcfSMSBrandingIcon,
  CcfEmailDomainsIcon,
  CcfPointsofContactIcon,
  CcfDispositionsIcon,
  CcfCampaignsIcon,
  CcfSkillControlIcon,
  CcfMessageTemplatesIcon,
  CcfCallingIcon,
  CcfCallSuppressionIcon,
  CcfDoNotCallIcon,
  CcfCustomDataDefinitionsIcon,
  CcfProcessQueueIcon,
  CcfSkillChannelSettingsIcon,
  CcfUnavailableCodesIcon,
  CcfStationsIcon,
  CcfAddressBooksIcon,
  CcfStationProfilesIcon,
  CcfAgentPatternsIcon,
  CcfLocationsIcon,
  CcfBusinessUnitsIcon,
  CcfDatabaseConnectorsIcon,
  CcfAgentMessagingIcon,
  CcfAgentIssuesIcon,
  CcfBrowseACDFilesIcon,
  CcfSlaIcon,
  CcfHoursOfOperationIcon,
  CcfCustomFieldsIcon,
  CcfRoutingIcon,
  CcfRoutingQueuesIcon,
  CcfBringYourOwnChannelIcon,
  CcfFormsIcon,
  CcfSatisfactionSurveysIcon,
  CcfFlashIcon,
  CcfDoubleArrowIcon,
  CcfUpArrowIcon,
  useTranslator,
} from '@nice-ccf/ui-controls';
import { useState } from 'react';
import './ccf-acd-left-nav.module.scss';
import styles from './ccf-acd-left-nav.module.scss';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import {
  globalActions,
  selectAcdLeftNavExpanded,
} from '../../global.app.slice';
import CcfAcdLeftNavAccordionStyles from './ccf-acd-left-nav-accordion.styles';

/* eslint-disable-next-line */
export interface CcfAcdLeftNavProps {}

const drawerWidth = window.innerWidth/5;

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    opacity: '1',
    height: '100%',
    width:'100%',
    //     backgroundColor: '#FFFFF',
    //     border: '1px solid #D2D8DB',
    // box-shadow: '0px 3px 4px rgba(0, 0, 0, 0.08)',
    '& .MuiDrawer-paper': {
      position: 'relative',
      height: '100%',
    },
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: (drawerWidth/10)*9,

    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    width: '60px !important',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    cursor: 'pointer',
    padding: theme.spacing(0, 1),
    minHeight: '36px',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  summaryContent: {
    '&.MuiAccordionSummary-content': {
      margin: 0,
    },
  },
  expandIcon: {
    margin: 0,
    position: 'absolute',
    right: '0',
    marginRight: '15px',
    '&.Mui-expanded': {
      transform: 'rotate(180deg)',
    },
  },
  listRoot: {
    padding: 0,
    overflowY: 'scroll',
    overflowX: 'hidden',
    height: '100%',
  },
  listItemIconRoot: {
    display: 'flex !important',
    justifyContent: 'space-around !important',
  },
  menuListItemIconRoot: {
    display: 'flex !important',
    justifyContent: 'space-between !important',
    minWidth: '40px',
  },
  listItemIcon: {
    justifyContent: 'center',
  },
  popover: {
    pointerEvents: 'none',
  },
}));

/**
 *
 * @param props - CcfAcdLeftNavProps
 * @returns
 * @example <CcfAcdLeftNav />
 */
export function CcfAcdLeftNav(props: CcfAcdLeftNavProps) {
  const classes = useStyles();
  const expandedAcdNav = useSelector(selectAcdLeftNavExpanded);
  const { setExpandedAcdLeftNav } = globalActions;
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [menuTitle, setMenuTitle] = useState('contactSettings');
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const theme = useTheme();
  const [translate] = useTranslator();
  const simStyles = CcfAcdLeftNavAccordionStyles(theme);
  const navigationItemsList = [
    {
      title: 'contactSettings',
      options: [
        'acdSkills',
        'Campaigns',
        'Dispositions',
        'PointsofContact',
        'EmailDomains',
        'SMSBranding',
        'SMSRegistration',
        'HoursofOperation',
        'ChatProfile',
        'Tags',
      ],
      isExpanded: true,
    },
    {
      title: 'OUTBOUND',
      options: ['SkillControl', 'SkillChannelSettings', 'MessageTemplates'],
      isExpanded: false,
    },
    {
      title: 'LISTS',
      options: [
        'Calling',
        'CallSuppression',
        'DoNotCall',
        'CustomDataDefinitions',
        'ProcessQueue',
      ],
      isExpanded: false,
    },
    {
      title: 'ACDSETTINGS',
      options: [
        'UnavailableCodes',
        'Stations',
        'AddressBooks',
        'StationProfiles',
        'QuickReplies',
        'AgentPatterns',
        'Locations',
      ],
      isExpanded: false,
    },
    {
      title: 'ACDCONFIGURATION',
      options: ['BusinessUnits', 'DatabaseConnectors'],
      isExpanded: false,
    },
    {
      title: 'SUPPORT',
      options: ['AgentMessaging', 'AgentIssues', 'BrowseACDFiles'],
      isExpanded: false,
    },
    {
      title: 'DFO',
      options: [
        'SLA',
        'hoursofOperation',
        'CustomFields',
        'Routing',
        'RoutingQueues',
        'BringYourOwnChannel',
        'Forms',
        'SatisfactionSurveys',
      ],
      isExpanded: false,
    },
  ];
  const [navItems, setNavItems] = useState(navigationItemsList);
  const [selectedMenu, setSelectedMenu] = useState<null | any>(navItems[0]);
  /**
   * Function to handle drawer open close
   * @example renderIcon()
   */
  const renderIcon = (title: string) => {
    switch (title) {
      case 'acdSkills':
        return <CcfAcdSupportIcon viewBox="0 0 22 21" />;
      case 'Campaigns':
        return <CcfCampaignsIcon />;
      case 'Dispositions':
        return <CcfDispositionsIcon />;
      case 'PointsofContact':
        return <CcfPointsofContactIcon />;
      case 'EmailDomains':
        return <CcfEmailDomainsIcon />;
      case 'SMSBranding':
        return <CcfSMSBrandingIcon />;
      case 'SMSRegistration':
        return <CcfSMSRegistrationIcon />;
      case 'HoursofOperation':
        return <CcfHoursofOperationIcon />;
      case 'ChatProfile':
        return <CcfChatProfileIcon />;
      case 'Tags':
        return <CcfTagsIcon />;
      case 'SkillControl':
        return <CcfSkillControlIcon />;
      case 'SkillChannelSettings':
        return <CcfSkillChannelSettingsIcon />;
      case 'MessageTemplates':
        return <CcfMessageTemplatesIcon />;
      case 'Calling':
        return <CcfCallingIcon />;
      case 'CallSuppression':
        return <CcfCallSuppressionIcon />;
      case 'DoNotCall':
        return <CcfDoNotCallIcon />;
      case 'CustomDataDefinitions':
        return <CcfCustomDataDefinitionsIcon />;
      case 'ProcessQueue':
        return <CcfProcessQueueIcon />;
      case 'UnavailableCodes':
        return <CcfUnavailableCodesIcon />;
      case 'Stations':
        return <CcfStationsIcon />;
      case 'AddressBooks':
        return <CcfAddressBooksIcon />;
      case 'StationProfiles':
        return <CcfStationProfilesIcon />;
      case 'QuickReplies':
        return <CcfFlashIcon style={{ fill: '#FF9400' }} />;
      case 'AgentPatterns':
        return <CcfAgentPatternsIcon />;
      case 'Locations':
        return <CcfLocationsIcon />;
      case 'BusinessUnits':
        return <CcfBusinessUnitsIcon />;
      case 'DatabaseConnectors':
        return <CcfDatabaseConnectorsIcon />;
      case 'AgentMessaging':
        return <CcfAgentMessagingIcon />;
      case 'AgentIssues':
        return <CcfAgentIssuesIcon />;
      case 'BrowseACDFiles':
        return <CcfBrowseACDFilesIcon />;
      case 'SLA':
        return <CcfSlaIcon />;
      case 'hoursofOperation':
        return <CcfHoursOfOperationIcon />;
      case 'CustomFields':
        return <CcfCustomFieldsIcon />;
      case 'Routing':
        return <CcfRoutingIcon />;
      case 'RoutingQueues':
        return <CcfRoutingQueuesIcon />;
      case 'BringYourOwnChannel':
        return <CcfBringYourOwnChannelIcon />;
      case 'Forms':
        return <CcfFormsIcon />;
      case 'SatisfactionSurveys':
        return <CcfSatisfactionSurveysIcon />;
      default:
        return <h1>No project match</h1>;
    }
  };

  /**
   * Function to handle drawer open close
   * @example renderIcon()
   */
  const renderIconLeftNav = (param: string) => {
    switch (param) {
      case 'contactSettings':
        return <CcfAcdContactSettingIcon />;
      case 'OUTBOUND':
        return <CcfAcdOutboundIcon />;
      case 'LISTS':
        return <CcfAcdListsIcon />;
      case 'ACDSETTINGS':
        return <CcfAcdSettingsIcon />;
      case 'ACDCONFIGURATION':
        return <CcfAcdConfigurationIcon />;
      case 'SUPPORT':
        return <CcfAcdSupportIcon />;
      case 'DFO':
        return <CcfAcdDFOIcon />;
      default:
        return '';
    }
  };

  /**
   * Used to render the Expanded list when drawer is open
   * @param title - string
   * @param listItem - menu element
   * @param navItem - string
   * @example renderExpandedMenuList(title, listItem, navItem)
   */
  const renderExpandedMenuList = (
    title: string,
    listItem: any,
    navItem?: any
  ) => {
    return (
      <div>
        <CcfAccordion
          sx={simStyles.accordionContainer}
          expanded={navItem?.isExpanded}
          onChange={() => expandedAcdNav && handleAccordianToggle(navItem)}
        >
          <CcfAccordionSummary
            expandIcon={
              <CcfUpArrowIcon
                sx={simStyles.expandedIcon}
                style={{ marginBottom: '10px' }}
              />
            }
            aria-controls="detail-content"
            id="acdLeftNav-header"
            sx={simStyles.accordionHeader}
            style={{ margin: '0px', minHeight: '45px' }}
          >
            <CcfTypography>{listItem}</CcfTypography>
          </CcfAccordionSummary>
          <CcfAccordionDetails
            sx={simStyles.content}
            className={styles.setAccordionDetailsItem}
          >
            {navItem?.options.map((option: any, idx: any) => {
              return (
                <ListItem
                  button
                  key={option}
                  selected={
                    selectedIndex === idx && menuTitle === navItem.title
                  }
                  onClick={() => selectedOptionHandler(idx, navItem.title)}
                >
                  <ListItemIcon className={classes.listItemIconRoot}>
                    {renderIcon(option)}
                  </ListItemIcon>
                  <ListItemText
                    primary={translate(option)}
                    primaryTypographyProps={{ style: { fontSize: '13px' } }}
                  />
                </ListItem>
              );
            })}
          </CcfAccordionDetails>
        </CcfAccordion>
      </div>
    );
  };

  /**
   * Used to render the icon list for menu when drawer is collapsed
   * @param title - string
   * @param listItem - menu element
   * @example renderCollapsedMenuList(title, listItem)
   */
  const renderCollapsedMenuList = (listItem: any) => {
    return <div className={styles.accordionContainer}>{listItem}</div>;
  };

  /**
   * Function to handle drawer open close
   * @example handleDrawerOpenClose()
   */
  const handleDrawerOpenClose = () => {
    dispatch(setExpandedAcdLeftNav(!expandedAcdNav));
  };

  /**
   * Function to handle Accoridian Toggle
   * @example handleAccordianToggle()
   */
  const handleAccordianToggle = (navItem: any) => {
    setNavItems(
      navItems.map((item: any) => {
        if (item.title === navItem.title) {
          return { ...item, isExpanded: !item.isExpanded };
        }
        return item;
      })
    );
    setNavItems((state) => {
      return state;
    });
  };

  /**
   * Function to handle selected Menu Option
   * @example selectedOptionHandler()
   */
  const selectedOptionHandler = (id: any, title: any) => {
    setSelectedIndex(id);
    setMenuTitle(title);
  };

  /**
   * @example handleClose()
   */
  const handleClose = () => {
    setAnchorEl(null);
  };

  /**
   * @example handlePopoverOpen()
   */
  const handlePopoverOpen = (e: any, item: any) => {
    setAnchorEl(e.currentTarget);
    setSelectedMenu(item);
  };

  /**
   * @example handlePopoverClose()
   */
  const handlePopoverClose = () => {
    setAnchorEl(null);
    setSelectedMenu(null);
  };

  return (
    <div className={classes.root}>
      <CssBaseline />

      <Drawer
        style={{ height: '37px !important' }}
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: expandedAcdNav,
          [classes.drawerClose]: !expandedAcdNav,
        })}
      >
        <div className={classes.toolbar}>
          {!expandedAcdNav ? (
            <CcfAssignmentCollapseIcon
              className={classes.expandIcon}
              onClick={handleDrawerOpenClose}
            ></CcfAssignmentCollapseIcon>
          ) : (
            <CcfAssignmentCollapseIcon
              className={styles.collapseIcon}
              onClick={handleDrawerOpenClose}
            ></CcfAssignmentCollapseIcon>
          )}
        </div>
        <Divider />
        <List className={classes.listRoot}>
          {navItems.map((item, index) => (
            <div key={item.title}>
              {expandedAcdNav
                ? renderExpandedMenuList(
                    item.title,
                    <ListItem button key={item.title}>
                      <ListItemText
                        primary={translate(item.title)}
                        primaryTypographyProps={{
                          style: { fontSize: '11px', fontWeight: 600 },
                        }}
                      />
                    </ListItem>,
                    item
                  )
                : renderCollapsedMenuList(
                    <ListItem
                      button
                      key={item.title}
                      onMouseEnter={(e) => handlePopoverOpen(e, item)}
                      onMouseLeave={handlePopoverClose}
                    >
                      <ListItemIcon
                        className={`${classes.listItemIconRoot} ${classes.listItemIcon}`}
                      >
                        {renderIconLeftNav(item.title)}
                      </ListItemIcon>
                    </ListItem>
                  )}
              <Divider />
            </div>
          ))}
        </List>
      </Drawer>
      <Popover
        id={'acd-navigation-popover'}
        className={classes.popover}
        open={Boolean(anchorEl)}
        keepMounted
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div className={styles.tooltipMenuContainer}>
          <div className={styles.headerSection}>
            <CcfTypography className={styles.headerTitle}>
              {translate(selectedMenu?.title)}
            </CcfTypography>
          </div>
          {selectedMenu?.options.map((option: any, idx: any) => {
            return (
              <ListItem
                button
                key={option}
                className={styles.tooltipMenuOption}
              >
                <ListItemIcon className={classes.menuListItemIconRoot}>
                  {renderIcon(option)}
                </ListItemIcon>
                <ListItemText
                  primary={translate(option)}
                  primaryTypographyProps={{ style: { fontSize: '13px' } }}
                />
              </ListItem>
            );
          })}
        </div>
      </Popover>
    </div>
  );
}

export default CcfAcdLeftNav;
